import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography, useTheme, Paper, Card, CardContent } from "@mui/material";

const MainDashboard = ({ title, icon, color = "#1976d2", description, to }) => {
  const theme = useTheme();
  
  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Card
        elevation={3}
        sx={{
          height: "100%",
          borderRadius: 4,
          background: theme.palette.mode === "light" ? "#ffffff" : "#1a202c",
          border: `1px solid ${theme.palette.mode === "light" ? "#e2e8f0" : "#2d3748"}`,
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          cursor: "pointer",
          position: "relative",
          overflow: "hidden",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: `0 20px 40px rgba(0,0,0,0.1)`,
            "& .icon-container": {
              transform: "scale(1.1)",
            },
            "& .card-content": {
              transform: "translateY(-2px)",
            }
          },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: `linear-gradient(90deg, ${color}, ${color}dd)`,
          }
        }}
      >
        <CardContent sx={{ p: 4, height: "100%", display: "flex", flexDirection: "column" }}>
          <Box
            className="icon-container"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${color}20, ${color}10)`,
              mb: 3,
              transition: "transform 0.3s ease",
              mx: "auto"
            }}
          >
            <Box sx={{ color: color, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {icon}
            </Box>
          </Box>
          
          <Box className="card-content" sx={{ textAlign: "center", flexGrow: 1, transition: "transform 0.3s ease" }}>
            <Typography
              variant="h6"
              fontWeight="600"
              sx={{
                color: theme.palette.mode === "light" ? "#2d3748" : "#e2e8f0",
                mb: 1,
                fontSize: "1.25rem"
              }}
            >
              {title}
            </Typography>
            
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.mode === "light" ? "#718096" : "#a0aec0",
                lineHeight: 1.6,
                fontSize: "0.875rem"
              }}
            >
              {description}
            </Typography>
          </Box>
          
          <Box
            sx={{
              mt: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: color,
              fontSize: "0.875rem",
              fontWeight: 500
            }}
          >
            <Typography variant="body2" sx={{ color: color, fontWeight: 500 }}>
              View Details →
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Link>
  );
};

export default MainDashboard;